import React from "react";
import ContactsPageGen from "./generated/ContactsPageGen";
import contactsService from "../../../services/legacy/contactsService";

const SHOW_IN_GRID = new Set(["contactpersonid", "name", "phone", "email"]);
const SHOW_IN_FILTER = new Set(["contactpersonid", "name", "phone", "email"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const ContactsPage = () => {
  const service = contactsService;
  return <ContactsPageGen service={service} transformColumns={transformColumns} />;
};

export default ContactsPage;